import { render, staticRenderFns } from "./TextRef.vue?vue&type=template&id=72e050cc&scoped=true&"
import script from "./TextRef.vue?vue&type=script&lang=js&"
export * from "./TextRef.vue?vue&type=script&lang=js&"
import style0 from "./TextRef.vue?vue&type=style&index=0&id=72e050cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e050cc",
  null
  
)

export default component.exports